const types = {
    CAT_SET_CURRENT_REVISION_ID: 'CAT_CURRENT_REVISION_ID',
    CAT_RESET_CURRENT_REVISION_ID: 'CAT_RESET_CURRENT_REVISION_ID',
};

const catActions = {
    types,

    setCurrentCatRevisionId(currentCatRevisionId) {
        return { type: this.types.CAT_SET_CURRENT_REVISION_ID, currentCatRevisionId };
    },
    resetCurrentCatRevisionId() {
        return { type: this.types.CAT_RESET_CURRENT_REVISION_ID };
    },
};

export default catActions;
